import React, { useEffect, useState } from "react";
import { CloudOff, ShieldCheck, Wifi } from "lucide-react";
import OutlookAppearancePane from "@/pages/OutlookAppearancePane";

function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}

export default function ClsConnectMobile() {
  const isOnline = useOnlineStatus();
  const isNativeRuntime = window.location.protocol === "capacitor:"
    || window.Capacitor?.isNativePlatform?.() === true;

  useEffect(() => {
    document.title = "CLS Connect";

    if (isNativeRuntime || !("serviceWorker" in navigator) || !window.isSecureContext) return undefined;
    navigator.serviceWorker.register("/cls-connect-sw.js", { scope: "/" }).catch((error) => {
      console.warn("CLS Connect service worker was not registered.", error);
    });
    return undefined;
  }, [isNativeRuntime]);

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-slate-950 [padding-top:env(safe-area-inset-top)] [padding-bottom:env(safe-area-inset-bottom)]">
      <div className="mx-auto flex w-[100vw] max-w-[430px] items-center justify-between gap-3 border-b border-white/10 bg-slate-950 px-4 py-2 text-white">
        <div className="flex items-center gap-2 text-[10px] font-semibold text-slate-300">
          <ShieldCheck className="h-3.5 w-3.5 text-emerald-400" />
          Secure mobile workspace
        </div>
        <div
          role="status"
          className={`flex items-center gap-1.5 rounded-full px-2 py-1 text-[9px] font-bold uppercase tracking-wide ${
            isOnline ? "bg-emerald-400/15 text-emerald-300" : "bg-amber-400/15 text-amber-200"
          }`}
        >
          {isOnline ? <Wifi className="h-3 w-3" /> : <CloudOff className="h-3 w-3" />}
          {isOnline ? "Online" : "Offline"}
        </div>
      </div>

      {!isOnline && (
        <div className="mx-auto w-[100vw] max-w-[430px] border-b border-amber-200 bg-amber-50 px-4 py-2 text-[11px] leading-4 text-amber-950">
          This device is offline. Do not submit calendar or Actionstep changes until it reconnects; CLS Connect does not queue writes silently.
        </div>
      )}

      <OutlookAppearancePane mobileMode />
    </div>
  );
}
